import { render, staticRenderFns } from "./clientUserList.vue?vue&type=template&id=37d64f73&scoped=true&"
import script from "./clientUserList.vue?vue&type=script&lang=js&"
export * from "./clientUserList.vue?vue&type=script&lang=js&"
import style0 from "./clientUserList.vue?vue&type=style&index=0&id=37d64f73&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d64f73",
  null
  
)

export default component.exports